import { routerMiddleware } from 'connected-react-router'
import { History } from 'history'
import { applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { ApplicationState, createRootReducer } from './store'
import thunkMiddleware from 'redux-thunk'
import websocket from 'store/middleware/reduxwebsockets'

export default function configureStore(
	history: History,
	initialState?: ApplicationState
): Store<ApplicationState> {
	const composeEnhancers = composeWithDevTools({})

	const store = createStore(
		createRootReducer(history) as any, // to work around what I'm fairly certain is a bug with combineReducers
		initialState,
		composeEnhancers(applyMiddleware(routerMiddleware(history), thunkMiddleware))
	)

	return store
}
